import { defineMessages } from 'react-intl';

export default defineMessages({
  MyCompensationServices: {
    id: 'auto_details_page.compensation_services.my_compensation_services',
  },
  FindOutMOre: {
    id: 'auto_details_page.compensation_services.find_out_more',
  },
  SlideOneTitle: {
    id: 'auto_details_page.compensation_services.slide_one_title',
  },
  SlideOneSubTitle: {
    id: 'auto_details_page.compensation_services.slide_one_sub_title',
  },
  SlideOneBodyContent: {
    id: 'check_auto_express.first_description',
  },
  SlideTwoTitle: {
    id: 'auto_details_page.compensation_services.slide_two_title',
  },
  SlideTwoSubTitle: {
    id: 'auto_details_page.compensation_services.slide_two_sub_title',
  },
  SlideTwoBodyContent: {
    id: 'alerte_mobile.description',
  },
  SlideThreeTitle: {
    id: 'auto_details_page.compensation_services.slide_three_title',
  },
  SlideThreeSubTitle: {
    id: 'auto_details_page.compensation_services.slide_three_sub_title',
  },
  SlideThreeBodyContent: {
    id: 'expertise_distance.description',
  },
});
